@use "../../sass/global/global" as *;

.ux-iws-teaser-comparison {
    display: flex;
    height: 100%;
    font-family: "Frutiger-Light", sans-serif;

    &__background {
        display: block;
        margin-bottom: 90px;
        background-size: cover;
        position: relative;
    }

    &__background ux-slider {
        @media (max-width: 1023px) {
            max-width: 580px;
            margin-left: auto;
            margin-right: auto;
        }

        &-slide {
            max-width: 440px;
        }
    }

    &__text-block {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 20px 0;
        font-family: "Frutiger-Light", sans-serif;

        &__title {
            font-size: 40px;
            font-family: "Frutiger-Bold", sans-serif;
            font-weight: 400;
            margin: 0 0 -5px;
            color: $color-black;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-rendering: optimizeLegibility;
        }

        p,
        ul {
            color: $color-black;
        }

        .ux-button {
            margin: 0 20px 20px 0;
        }

        .ux-button:not(.ux-button--primary) {
            background-color: $color-white;
        }
    }

    &__title {
        text-transform: uppercase;
        font-family: "Frutiger-Bold", sans-serif;
        font-size: 16px;
    }

    &__sub-title {
        font-size: 23px;
        color: $color-black;
        font-family: "Frutiger-Light", sans-serif;
    }

    &__text {
        font-size: 16px;
    }

    &__slider {
        margin-top: 20px;
        max-width: 712px;

        @media (min-width: 1024px) {
            margin-bottom: -50px;
        }
    }

    &__slider--alignLeft {
        margin-left: auto;
    }
}

ux-iws-teaser-comparison[dark] .ux-iws-teaser-comparison__text-block {
    &__title,
    p,
    ul {
        color: #fff;
    }

    // this styles the old PL list, that is used in TYPO3
    // stylelint-disable-next-line
    .list-styled li::before {
        background-color: #fff;
    }
}
